import { BrowserRouter as Router } from 'react-router-dom';
import { Suspense, useEffect } from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import LanguageRoutes from './components/LanguageRoutes';
import ScrollToTop from './components/ScrollToTop';
import './i18n';
import './App.css';

// Loading component for i18n initialization
const AppLoading = () => (
  <div className="app-loading">
    <div className="loading-spinner"></div>
    <p>Loading...</p>
  </div>
);

function App() {
  // Disable browser scroll restoration
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Suspense fallback={<AppLoading />}>
        <LanguageProvider>
          <div className="App">
            <LanguageRoutes />
          </div>
        </LanguageProvider>
      </Suspense>
    </Router>
  );
}

export default App;
